import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { ChromePicker } from "react-color";
import { FiSettings } from "react-icons/fi";

const ThemeSelector = () => {
  const [themeColor, setThemeColor] = useState("#f59e0b");
  const [status, setStatus] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const pickerRef = useRef();

  useEffect(() => {
    const fetchSetupInfo = async () => {
      try {
        const accessToken = sessionStorage.getItem("access_token");
        const response = await axios.get(`${baseURL}/fetchSetup`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setThemeColor(response.data[0]?.theme_color || "#f59e0b");
      } catch (error) {
        console.error("Error fetching setup info:", error);
      }
    };

    fetchSetupInfo();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const updateThemeColor = async () => {
    try {
      await axios.post(`${baseURL}/updateThemeColor`, {
        theme_color: themeColor,
      });
      setStatus("Theme color updated successfully!");
      setTimeout(() => {
        setStatus("");
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error updating theme color:", error);
      setStatus("Failed to update theme color");
    }
  };

  return (
    <div className="relative inline-block">
      {/* Settings Button */}
      <button
        onClick={() => setShowPicker(!showPicker)}
        className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 shadow"
        title="Change Theme Color"
      >
        <FiSettings className="text-2xl text-gray-700" />
      </button>

      {/* Color Picker */}
      {showPicker && (
        <div
          ref={pickerRef}
          className="absolute right-0 top-full mt-2 z-50 p-4 bg-white shadow-xl rounded-lg"
          style={{ minWidth: "240px" }}
        >
          <ChromePicker
            color={themeColor}
            onChangeComplete={(color) => setThemeColor(color.hex)}
          />
          <button
            onClick={updateThemeColor}
            className="mt-3 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 w-full"
          >
            Save
          </button>
          {status && <p className="text-sm text-gray-600 mt-2">{status}</p>}
        </div>
      )}
    </div>
  );
};

export default ThemeSelector;
